import { render, staticRenderFns } from "./BusinessEntities.vue?vue&type=template&id=98beeb70&"
import script from "./BusinessEntities.vue?vue&type=script&lang=js&"
export * from "./BusinessEntities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports